import { Component, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { formatDate } from '@angular/common';
import { AuthService } from 'src/app/services/http/auth.service';
import { UserService } from 'src/app/services/http/user.service';
import { IFilterResponse } from 'src/app/interface/filter-response';
import { RouteService } from 'src/app/services/http/route.service';
import { RegionService } from 'src/app/services/http/region.service';
import { IOption } from 'src/app/interface/option';
import { DistrictService } from 'src/app/services/http/district.service';
import { ItineraryService } from 'src/app/services/http/itinerary.service';
import { IAppliedFilter } from 'src/app/interface/applied-filter';

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss']
})
export class TableFilterComponent implements OnInit {
  @Input() filterSelection: string[] = [];
  @Input() showSearch: boolean = false;
  @Input() searchPlaceholder: string = '';
  @Input() appliedFilters: IAppliedFilter[] = []
  @Input('startDate') set startDate(value: any) {
    this.dateApplied = true;
    this.date = value;
  }
  @Input('resetFilters') set resetFilters(value: any) {
    this.clearAllFilters()
  }

  @Input() meterMakeOptions: IOption[] = [{ key: "0", value: "Flat Rate" }];
  @Input() connectionTypeOptions: IOption[] = [];
  @Input() billPeriodOptions: string[] = [];
  @Input() customerTypeOptions: IOption[] = [];
  @Input() failedValidationStatusOptions: IOption[] = [{ key: "0", value: "Pending Review" }, { key: "1", value: "Processed" }];
  @Input() readTypeOptions: IOption[] = [{ key: "1", value: "Autofetched" }, { key: "2", value: "Upload" }, { key: "6", value: "System Estimated" }];
  @Input() validationStatusOptions: IOption[] = [{ key: "1", value: "Pending" }, { key: "2", value: "Confirmed" }];
  @Input() billStatusOptions: IOption[] = [{ key: 1, value: "Pending" }, { key: 2, value: "Processed" }, { key: 3, value: "Issued" }];
  @Input() emailOptions: IOption[] = [{ key: 1, value: "With Email" }, { key: 2, value: "Without Email" }];
  @Input() meterTypeOptions: IOption[] = [{ key: 1, value: "AMR" }, { key: 2, value: "NON AMR" }];
  @Input() minimumBalanceOptions: IOption[] = [{ key: 1, value: "<1000" }, { key: 2, value: "1001-10,000" }, { key: 3, value: "10,001-100,000" }, { key: 4, value: "100,001-1,000,000" }, { key: 5, value: ">1,000,000" }];
  @Input() fraudTypeOptions: IOption[] = [{ key: 1, value: "Fraud" }, { key: 2, value: "Non Fraud" }];
  @Input() dueDateOptions: IOption[] = [{ key: 1, value: "Test 1" }, { key: 2, value: "Test 2" }];
  @Input() eventTypeOptions: IOption[] = [{ key: 0, value: "Recovery Billing" }, { key: 1, value: "Recovery Bill Cancellation" }, { key: 2, value: "Payment Plan Modification" }, { key: 3, value: "Regular Monthly Billing" }, { key: 4, value: "Rebilling" }, { key: 5, value: "Bill Regularization"}];
  @Input() customerActivityTypeOptions: IOption[] = [{ key: "1", value: "MDAs" }, { key: "2", value: "GWCL" }, { key: "3", value: "SOEs" }, { key: "4", value: "Private Sales" }, { key: "5", value: "SHS" }];
  @Input() debtAgingOptions: IOption[] = [{ key: "0", value: "0 - 30" }, { key: "1", value: "31 - 60" }, { key: "2", value: "61 - 90" }, { key: "3", value: "91 - 120" }, { key: "4", value: "> 120" }];
  @Input() accountTypeOptions: IOption[] = [{ key: "0", value: "Prepaid" }, { key: "1", value: "Postpaid" }];
  // @Input() usageCalculationOptions: IOption[] = [{ key: 1, value: "Actual" }, { key: 2, value: "Estimated" }];
  @Input() auditDescriptionOptions: IOption[] = [];
  @Input() jobTitleOptions: string[] = [];
  @Input() fraudStatusOptions: IOption[] = [];
  @Input() tariffOptions: IOption[] = [];
  @Input() groupOptions: IOption[] = [];
  @Input() districtOptionsPrepay: IOption[] = [];
  @Input() meterMakeOptionsPrepay: IOption[] = [];
  @Input() auditTrailActions: IOption[] = [];

  @Output() filterChange: EventEmitter<IFilterResponse> = new EventEmitter()

  regionOptions: IOption[] = [];
  districtOptions: IOption[] = [];
  routeOptions: IOption[] = [];
  itineraryOptions: IOption[] = [];
  selectedGroup: IOption | null = null;
  selectedAuditDescription: IOption | null = null;
  selectedAuditTrailAction: IOption | null = null;

  date: any = '';
  dateApplied = false;

  dateFrom: string = '';
  dateTo: string = '';
  to: string = '';
  from: string = '';

  searchInput = '';
  selectSltStatusValue = '';
  selectRegionValue = '';
  selectDistrictValue = '';
  selectRouteValue = '';
  selectItineraryValue = '';
  selectReadTypeValue = '';
  selectValidationStatusValue = '';
  selectFailedValidationStatusValue = ''
  selectMeterMakeValue = '';
  selectConnectionTypeValue = '';
  selectEmailValue = '';
  selectJobTitleValue = '';
  selectBillStatus = '';
  selectFraudStatus = '';
  selectIsEstimated = '';
  selectMeterTypeValue = '';
  selectMinimumBalanceValue = '';
  selectCustomerActivityTypeValue = '';
  selectDebtAgingValue = '';
  selectAccountTypeValue = '';
  selectConsumptionValue = '';
  selectFraudTypeValue = '';
  selectEventTypeValue = '';
  selectDueDateValue = '';

  disableDistrictSelect = true;
  disableRouteSelect = true;
  disableItinerarySelect = true;

  districtId = '';
  regionIds = '';

  selectedTariff: IOption | null = null;
  selectedDistrictPrepay: IOption | null = null;
  selectedMeterMakePrepay: IOption | null = null;

  constructor(private authService: AuthService,
    private toastr: ToastrService,
    private districtService: DistrictService,
    private routeService: RouteService,
    private regionService: RegionService,
    private itinearyService: ItineraryService,
    private userService: UserService) { }

  ngOnInit(): void {
    let decodedToken = this.authService.decodeJWTToken();
  }

  getInitData(){
    if (this.filterSelection.includes("region")) {
      if (this.districtId == null && this.regionIds.length == 0) {
        this.getRegionsForOptions();
      }

      if (this.districtId == null && this.regionIds.length > 0) {
        this.getRegionsForOptionsByUser();
      }

      if (this.districtId !== null)
        this.getRouteForOptionsByDistrict()
    }
  }

  onFilterChange() {
    this.filterChange.emit({
      filters: this.appliedFilters,
      searchFilter: this.searchInput,
      date: this.date,
      from: this.from,
      to: this.to,
      dateFrom: this.dateFrom,
      dateTo: this.dateTo
    });
  }

  clearAllFilters() {
    this.appliedFilters = [];
    this.selectRegionValue = '';
    this.selectDistrictValue = '';
    this.selectRouteValue = '';
    this.selectItineraryValue = '';
    this.selectSltStatusValue = '';
    this.selectReadTypeValue = '';
    this.selectValidationStatusValue = '';
    this.selectFailedValidationStatusValue = '';
    this.selectMeterMakeValue = '';
    this.selectConnectionTypeValue = '';
    this.selectEmailValue = '';
    this.selectMeterTypeValue = '';
    this.selectMinimumBalanceValue = '';
    this.selectCustomerActivityTypeValue = '';
    this.selectDebtAgingValue = '';
    this.selectAccountTypeValue = '';
    this.selectFraudTypeValue = '';
    this.selectEventTypeValue = '';
    this.selectDueDateValue = '';
    this.selectBillStatus = '';
    this.selectFraudStatus = '';
    this.selectedGroup = null;
    this.date = '';
    this.dateFrom = '';
    this.dateTo = '';
    this.from = '';
    this.to = '';
    this.searchInput = '';
    this.selectJobTitleValue = '';
    this.selectIsEstimated = '';
    this.selectConsumptionValue = '';
    this.selectedAuditDescription = null;
    this.selectedAuditTrailAction = null;
    if (this.districtId == '') {
      this.disableDistrictSelect = true;
      this.disableRouteSelect = true;
    }
    this.disableItinerarySelect = true;
    this.dateApplied = false;
    this.selectedTariff = null;
    this.selectedDistrictPrepay = null;
    this.selectedMeterMakePrepay = null;
    this.onFilterChange();
  }

  getAppliedFilterName(key: any, name: string) {
    let temp: any;
    if (!this.districtId && name == 'region')
      temp = this.regionOptions.filter(x => x.key == key);

    if (!this.districtId && name == 'district')
      temp = this.districtOptions.filter(x => x.key == key);

    if (name == 'route')
      temp = this.routeOptions.filter(x => x.key == key);

    if (name == 'itinerary')
      temp = this.itineraryOptions.filter(x => x.key == key);

    if (name == 'slt status')
      temp = this.customerTypeOptions.filter(x => x.key == key);

    if (name == 'read type')
      temp = this.readTypeOptions.filter(x => x.key == key);

    if (name == 'validation status')
      temp = this.validationStatusOptions.filter(x => x.key == key);

    if (name == 'status')
      temp = this.failedValidationStatusOptions.filter(x => x.key == key);

    if (name == 'meter make')
      temp = this.meterMakeOptions.filter(x => x.key == key);

    if (name == 'connection type')
      temp = this.connectionTypeOptions.filter(x => x.key == key);

    if (name == 'bill status')
      temp = this.billStatusOptions.filter(x => x.key == key);

    if (name == 'email')
      temp = this.emailOptions.filter(x => x.key == key);

    if (name == 'meter type')
      temp = this.meterTypeOptions.filter(x => x.key == key);

      if (name == 'minimum balance')
        temp = this.minimumBalanceOptions.filter(x => x.key == key);

    if (name == 'customer activity type')
      temp = this.customerActivityTypeOptions.filter(x => x.key == key);

    if (name == 'debt aging')
      temp = this.debtAgingOptions.filter(x => x.key == key);

    if (name == 'account type')
      temp = this.accountTypeOptions.filter(x => x.key == key);
    
    if (name == 'audit description')
      temp = this.auditDescriptionOptions.filter(x => x.key == key);
    
    if (name == 'audit trail')
      temp = this.auditTrailActions.filter(x => x.key == key);

    if (name == 'fraud type')
      temp = this.fraudTypeOptions.filter(x => x.key == key);

    if (name == 'event type')
      temp = this.eventTypeOptions.filter(x => x.key == key);

    if(name == 'jobTitle')
      return this.selectJobTitleValue;

    if(name == 'consumption'){
      if(key == 1){
        return "Negative"
      } else if (key == 0){
        return "Positive"
      }
    }

    if(name == 'estimation status'){
      if(key == 1){
        return "Estimated"
      } else if (key == 0){
        return "Actual"
      }
    }
    
    if (temp && temp.length > 0)
      return temp[0].value;

    if(name == 'Fraud Status') {
      const fraudStatus = this.fraudStatusOptions.filter(x => x.key == key)[0];
      return fraudStatus.value;
    }

    if (name == 'tariff') {
      return this.selectedTariff?.value;
    }

    if (name == 'districtPrepay') {
      return this.selectedDistrictPrepay?.value;
    }

    if (name == 'meterMakePrepay') {
      return this.selectedMeterMakePrepay?.value;
    }

    if (name == 'accounts group') {
      return this.selectedGroup?.value;
    }

    return '';
  }

  handleApplyFilter(value: any, name: string) {
    var textValue = '';
    if (name == 'region') {
      var temp = [];
      temp.push(value);
      this.getDistrictsForOptions(value);
      value = temp;
      this.disableDistrictSelect = false;
      this.selectDistrictValue = '';
      this.selectRouteValue = '';
      this.selectItineraryValue = '';
      this.disableRouteSelect = true;
      this.disableItinerarySelect = true;
      this.appliedFilters = this.appliedFilters.filter((obj: IAppliedFilter) => (obj.name !== 'district'));
      this.appliedFilters = this.appliedFilters.filter((obj: IAppliedFilter) => (obj.name !== 'route'));
      this.appliedFilters = this.appliedFilters.filter((obj: IAppliedFilter) => (obj.name !== 'itinerary'));
      let optionOBJ = this.regionOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'district') {
      var temp = [];
      temp.push(value);
      this.getRouteForOptionsByDistrict();
      value = temp;
      this.disableRouteSelect = false;
      this.selectRouteValue = '';
      this.selectItineraryValue = '';
      this.disableItinerarySelect = true;
      this.appliedFilters = this.appliedFilters.filter((obj: IAppliedFilter) => (obj.name !== 'route'));
      this.appliedFilters = this.appliedFilters.filter((obj: IAppliedFilter) => (obj.name !== 'itinerary'));
      let optionOBJ = this.districtOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'route') {
      var temp = [];
      temp.push(value);
      this.getItineraryForOptionsByRoute(value);
      value = temp;
      this.disableItinerarySelect = false;
      this.selectItineraryValue = '';
      this.appliedFilters = this.appliedFilters.filter((obj: IAppliedFilter) => (obj.name !== 'itinerary'));
      let optionOBJ = this.routeOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'itinerary') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.itineraryOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'slt status') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.customerTypeOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }
    if (name == 'date') {
      this.dateApplied = true;
      this.onFilterChange();
      return;
    }
    if (name == 'bill status') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.billStatusOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'email') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.emailOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'meter type') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.meterTypeOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'minimum balance') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.minimumBalanceOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'customer activity type') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.customerActivityTypeOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'debt aging') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.debtAgingOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'account type') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.accountTypeOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'meter make') {
      let optionOBJ = this.meterMakeOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'fraud type') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.fraudTypeOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'event type') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.eventTypeOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'dueDate') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.dueDateOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'tariff') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.tariffOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'districtPrepay') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.districtOptionsPrepay.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (name == 'meterMakePrepay') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.meterMakeOptionsPrepay.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if(name == 'jobTitle') {
      var temp = [];
      temp.push(value);
      value = temp;
    }

    if(name == 'consumption') {
      var temp = [];
      temp.push(value)
      value = temp;
    }

    if(name == 'estimation status') {
      var temp = [];
      temp.push(value)
      value = temp;
    }

    if (name == 'Fraud Status') {
      var temp = [];
      temp.push(value);
      value = temp;
      let optionOBJ = this.fraudStatusOptions.find((obj: IOption) => (obj.key == value))?.value;
      if (optionOBJ)
        textValue = optionOBJ;
    }

    if (value.length === 0) {
      let newArr: any = [];
      this.appliedFilters.filter((item: any) => (
        item.name !== name ? newArr.push(item) : null
      ));
      this.appliedFilters = newArr;
      this.onFilterChange();
      return;
    }

    const isObjectPresent = this.appliedFilters.find((o: any) => o.name === name);
    if (isObjectPresent) {
      isObjectPresent['value'] = value;
      isObjectPresent['textValue'] = textValue;
    } else {
      this.appliedFilters.push({ name, value, textValue });
    }

    this.onFilterChange();
  }

  handleRemoveFilter(name: any) {
    this.appliedFilters = this.appliedFilters.filter((obj: any) => (
      obj.name !== name
    ));
    switch (name) {
      case 'region':
        this.selectRegionValue = '';
        this.selectDistrictValue = '';
        this.selectRouteValue = '';
        this.selectItineraryValue = '';
        this.disableDistrictSelect = true;
        this.disableRouteSelect = true;
        this.disableItinerarySelect = true;
        this.appliedFilters = this.appliedFilters.filter((obj: any) => (obj.name !== 'district'));
        this.appliedFilters = this.appliedFilters.filter((obj: any) => (obj.name !== 'route'));
        this.appliedFilters = this.appliedFilters.filter((obj: any) => (obj.name !== 'itinerary'));
        break;
      case "district":
        this.selectDistrictValue = '';
        this.selectRouteValue = '';
        this.selectItineraryValue = '';
        this.disableRouteSelect = true;
        this.disableItinerarySelect = true;
        this.appliedFilters = this.appliedFilters.filter((obj: any) => (obj.name !== 'route'));
        this.appliedFilters = this.appliedFilters.filter((obj: any) => (obj.name !== 'itinerary'));
        break;
      case "route":
        this.selectRouteValue = '';
        this.selectItineraryValue = '';
        this.disableItinerarySelect = true;
        this.appliedFilters = this.appliedFilters.filter((obj: any) => (obj.name !== 'itinerary'));
        break;
      case "itinerary":
        this.selectItineraryValue = '';
        break;
      case "slt status":
        this.selectSltStatusValue = '';
        break;
      case "read type":
        this.selectReadTypeValue = '';
        break;
      case "validation status":
        this.selectValidationStatusValue = '';
        break;
      case "date":
        this.date = '';
        this.dateApplied = false;
        break;
      case "connection type":
        this.selectConnectionTypeValue = '';
        break;
      case "meter make":
        this.selectMeterMakeValue = '';
        break;
      case "status":
        this.selectFailedValidationStatusValue = '';
        break;
      case "bill status":
        this.selectBillStatus = '';
        break;
      case "email":
        this.selectEmailValue = '';
        break;
      case "meter type":
          this.selectMeterTypeValue = '';
          break;
      case "minimum balance":
          this.selectMinimumBalanceValue = '';
          break;
      case "customer activity type":
        this.selectCustomerActivityTypeValue = '';
        break;
      case "debt aging":
        this.selectDebtAgingValue = '';
        break;
      case "account type":
        this.selectAccountTypeValue = '';
        break;
      case "consumption":
        this.selectConsumptionValue = '';
        break;
      case "fraud type":
          this.selectFraudTypeValue = '';
          break;
      case "event type":
          this.selectEventTypeValue = '';
          break;
      case "dueDate":
          this.selectDueDateValue = '';
          break;
      case "dateRange":
        this.dateFrom = '';
        this.dateTo = '';
        this.from = '';
        this.to = '';
        this.dateApplied = false;
        break;
      case "jobTitle":
        this.selectJobTitleValue = '';
        break;
      case "audit description":
        this.selectedAuditDescription = null;
        break;
      case "audit trail":
        this.selectedAuditTrailAction = null;
        break;
      case "Fraud Status":
        this.selectFraudStatus = '';
        break;
      case "tariff":
        this.selectedTariff = null;
        break;
      case "districtPrepay":
        this.selectedDistrictPrepay = null;
        break;
      case "meterMakePrepay":
        this.selectedMeterMakePrepay = null;
        break;
      case "estimation status":
        this.selectIsEstimated = '';
        break;
      case "accounts group":
        this.selectedGroup = null
    }
    this.onFilterChange();
  }

  onDate(event: MatDatepickerInputEvent<any>, name: string): void {

    if (name == 'dateFrom') {
      this.from = formatDate(event.value, 'dd-MM-yyyy', 'en-US');
      this.dateFrom = event.value;
    }

    else if (name == 'dateTo') {
      this.to = formatDate(event.value, 'dd-MM-yyyy', 'en-US');
      this.dateTo = event.value;
    }
  }


  catchEnter(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.onFilterChange()
    }
  }

  getRegionsForOptions() {
    this.regionService.getRegionsForOptions().subscribe(response => {
      this.regionOptions = response.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  getRegionsForOptionsByUser() {
    this.regionService.getRegionsForOptionsByUser().subscribe(response => {
      this.regionOptions = response.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  getRouteForOptionsByDistrict() {
    this.routeService.getRouteForOptionsByDistrict(this.districtId == '' ? this.selectDistrictValue : this.districtId).subscribe(response => {
      this.disableRouteSelect = false;
      this.routeOptions = response.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  getDistrictsForOptions(regionId: number) {
    this.districtService.getDistrictsForOptionsByRegion(regionId).subscribe(response => {
      this.districtOptions = response.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  getItineraryForOptionsByRoute(routeId: number) {
    this.itinearyService.getItineraryForOptionsByRoute(routeId).subscribe(response => {
      this.itineraryOptions = response.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  auditDescriptionChanged(option: IOption) {
    const oldValueIndex = this.appliedFilters.findIndex((element: IAppliedFilter) => element.name === 'audit description');
    
    // If audit desc option is already added then just change the existing values
    if (oldValueIndex !== -1) {
      this.appliedFilters[oldValueIndex].value = [option.key];
      this.appliedFilters[oldValueIndex].textValue = option.value;
    } else {
      this.appliedFilters.push({ name: 'audit description', value: [option.key], textValue: option.value });
    }

    this.selectedAuditDescription = option;
    this.onFilterChange();
  }

  auditTrailChanged(option: IOption) {
    const oldValueIndex = this.appliedFilters.findIndex((element: IAppliedFilter) => element.name === 'audit trail');
    
    if (oldValueIndex !== -1) {
      this.appliedFilters[oldValueIndex].value = [option.key];
      this.appliedFilters[oldValueIndex].textValue = option.value;
    } else {
      this.appliedFilters.push({ name: 'audit trail', value: [option.key], textValue: option.value });
    }

    this.selectedAuditTrailAction = option;
    this.onFilterChange();
  }

  tariffChanged(option: IOption) {
    const oldValueIndex = this.appliedFilters.findIndex((element: IAppliedFilter) => element.name === 'tariff');
    
    if (oldValueIndex !== -1) {
      this.appliedFilters[oldValueIndex].value = [option.key];
      this.appliedFilters[oldValueIndex].textValue = option.value;
    } else {
      this.appliedFilters.push({ name: 'tariff', value: [option.key], textValue: option.value });
    }
    this.selectedTariff = option;
    this.onFilterChange();
  }

  districtPrepayChanged(option: IOption) {
    const oldValueIndex = this.appliedFilters.findIndex((element: IAppliedFilter) => element.name === 'districtPrepay');
    
    if (oldValueIndex !== -1) {
      this.appliedFilters[oldValueIndex].value = [option.key];
      this.appliedFilters[oldValueIndex].textValue = option.value;
    } else {
      this.appliedFilters.push({ name: 'districtPrepay', value: [option.key], textValue: option.value });
    }
    this.selectedDistrictPrepay = option;
    this.onFilterChange();
  }

  accountGroupChanged(option: IOption) {
    const oldValueIndex = this.appliedFilters.findIndex((element: IAppliedFilter) => element.name === 'accounts group');
    
    if (oldValueIndex !== -1) {
      this.appliedFilters[oldValueIndex].value = [option.key];
      this.appliedFilters[oldValueIndex].textValue = option.value;
    } else {
      this.appliedFilters.push({ name: 'accounts group', value: [option.key], textValue: option.value });
    }
    this.selectedGroup = option;
    this.onFilterChange();
  }

  meterMakePrepayChanged(option: IOption) {
    const oldValueIndex = this.appliedFilters.findIndex((element: IAppliedFilter) => element.name === 'meterMakePrepay');
    
    if (oldValueIndex !== -1) {
      this.appliedFilters[oldValueIndex].value = [option.key];
      this.appliedFilters[oldValueIndex].textValue = option.value;
    } else {
      this.appliedFilters.push({ name: 'meterMakePrepay', value: [option.key], textValue: option.value });
    }
    this.selectedMeterMakePrepay = option;
    this.onFilterChange();
  }
}
